<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.atividade_continua"
            :valid.sync="fieldsComputed.atividade_continua.valid"
            :label="fieldsComputed.atividade_continua"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.data_inicio"
            :valid.sync="fieldsComputed.data_inicio.valid"
            :label="fieldsComputed.data_inicio"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.data_fim"
            :valid.sync="fieldsComputed.data_fim.valid"
            :label="fieldsComputed.data_fim"
            :editable="canEdit"
          ></input-v>
        </div>
      </div>
      <div class="row mt-n2" v-if="projeto.atividade_continua == 1">
        <div class="col">
          <input-v
            v-model="projeto.atividadeAnoBase"
            :valid.sync="fieldsComputed.atividadeAnoBase.valid"
            :label="fieldsComputed.atividadeAnoBase"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.info_complementar"
            :valid.sync="fieldsComputed.info_complementar.valid"
            :label="fieldsComputed.info_complementar"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LBEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
  },
  data() { 
    return {
      fields,
    }
  },
  computed: {
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.descricao);
      const isContinua = this.projeto.atividade_continua == 1;
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (field.key === 'atividadeAnoBase' && !isContinua) {
            field.rules = [];
          } else if (!isStrict) {
            // Se nao for strict, remove a obrigatoriedade
            field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
  },
  methods: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
</style>
